(function ($) {

    $.fn.mlm2 = function (objContainer, strFunctionalityMode, iColumns) {

        //Getting name of object container
        objContainerID = objContainer.attr('id');

        if (strFunctionalityMode == "VerticalExpandable") {

            objContainer.find(".VerticalExpandable strong").click(function () {

                //Setting children container that will be shown or hidden  
                var par = $(this).parent("li").find("> ul");
                //If it is hidden
                if (par.css("display") == "none") {

                    par.show("fast");
                    //+-
                    $(this).css("display", "none").parent("li").find("> .MinusLevel").css("display", "block");
                    $(this).parent('li').find('> a').addClass('Expanded');

                } else {

                    par.hide("fast");
                    //+-
                    $(this).css("display", "none").parent("li").find("> .PlusLevel").css("display", "block");
                    $(this).parent('li').find('> a').removeClass('Expanded');

                }

            });
        }

        if (strFunctionalityMode == "HorizontalExpandable") {

            objContainer.find(".HorizontalExpandable li").hover(function () {
                //Setting children container that will be shown or hidden
                var par = $(this).find("> ul");
                par.stop(true, true).delay(200).show('fast');
                //+-
                $(this).find("> .PlusLevel").css("display", "none").parent("li").find("> .MinusLevel").css("display", "block");
                $(this).parent('li').find('> a').addClass('Expanded');

            }, function () {

                var par = $(this).find("> ul");
                par.stop(true, true).delay(200).hide("fast");
                //+-
                $(this).find("> .MinusLevel").css("display", "none").parent("li").find("> .PlusLevel").css("display", "block");
                $(this).parent('li').find('> a').removeClass('Expanded');
            });

        }

        if (strFunctionalityMode == "VerticalExpandable" || strFunctionalityMode == "VerticalByLevel") {

            //Checking if item page, if yes, then setting Select class to parent PageID
            var curItemID = $('#' + objContainerID + '_hCurrentItemID').attr('value');
            if (curItemID > 0) {

                var parentPageID = $('#' + objContainerID + '_hCurrentPageID').attr('value') - 1;
                $('.PageID-' + parentPageID).addClass('Selected');

            }

            //Making child with "selected" class to be displayed
            $(".VerticalExpandable .Selected, .VerticalByLevel .Selected").parents("ul").css("display", "block").parent("li").find(" > .MinusLevel").css("display", "block").parent("li").find(" > .PlusLevel").css("display", "none");

            $('.MinusLevel').each(function () {

                if ($(this).css('display') == 'block') {
                    $(this).parent('li').addClass('Expanded');
                }

            });

        }

        if (strFunctionalityMode == "HorizontalColumnar") {
            var hArr = new Array();
            var hSum = 0;
            var iLast = 0;

            objContainer.find(".Level-1 > li").each(function (i) {
                hArr[i] = $(this).height();
                iLast = i;
                //All blocks height summ
                hSum += hArr[i];
            });
			

            if (iColumns > hArr.length) {
                iColumns = hArr.length;
            }
			

            //Sorting columns by height DESC
            var ihArr = hArr;
            ihArr.sort(sortNumber);
            //Average column height according to all blocks height summ
            var hAverage = Math.floor(hSum / iColumns) + 1;

            //Building columns
            for (var col = 1; col <= iColumns; col++) {
                objContainer.find(".MiddleBox").append('<ul id="Col-' + col + '" class="Column ' + strFunctionalityMode + ' "></ul>');
                if (hArr.length <= iColumns) {
                    objContainer.find(".Level-1 > .Item-" + col).appendTo(objContainer.find("#Col-" + col));
                }
            }

            //Calculating column width
            var mCol = objContainer.find(".MiddleBox > .Column");
            var mColWidth = Math.floor(objContainer.find(".MiddleBox").width() / iColumns) - mCol.css("padding-left").replace("px", "") - mCol.css("padding-right").replace("px", "");
            if (mColWidth > 0) {
                mCol.css("width", mColWidth + "px");
            }

            //If amount of blocks is same or smaller then amount of columns
            if (hArr.length > iColumns) {
                //If maximum block height is more then average column height
                var hCurSum = 0;
                var hAverageSum = 0;
                var iCounter = 0;
                for (var i = 0; i < hArr.length; i++) {
                    hCur = hArr[i];

                    if (hCur > hAverage) {
                        hCur = 0;
                    }

                    hCurSum += hCur;

                    if (hCurSum > hAverage) {
                        hAverageSum += hCurSum;
                        hCurSum = 0;
                        if (i < iLast) {
                            i--;
                        }
                        iCounter++;
                    } else {
                        if (i == iLast) {
                            hAverageSum += hCurSum;
                            iCounter++;
                        }
                    }
                }

                var hCol = Math.floor(hAverageSum / iCounter) + 10;

            }

            var hCur = 0;
            var colCur = 1;

            //Inserting blocks into builded columns
            objContainer.find(".Level-1 > li").each(function (i) {

                var th = $(this);

                //Calculating height of the blocks that have been inserted so far
                hCur += th.height();

                //If current block still fits
				if (i == 0) {
					th.appendTo(objContainer.find("#Col-" + colCur));
				} else if (hCur <= hCol) {
                    th.appendTo(objContainer.find("#Col-" + colCur));
                } else {
                    colCur++;
                    th.appendTo(objContainer.find("#Col-" + colCur));
                    hCur = th.height();
                }

            });

            //If something went wrong and blocks did not fit the columns
            if (objContainer.find(".MiddleBox > .Level-1 > li").length > 0) {
                objContainer.find(".MiddleBox > .Level-1 > li").appendTo(objContainer.find("#Col-" + iColumns));
                //objContainer.find(".MiddleBox").prepend('<big style="color:#f00; display:block; font-size: 14px;">Warning! Selected Height is too low! Some elements probably are hidden!</big>');
            }

            //Removing empty ul
            objContainer.find(".MiddleBox > .Level-1").remove();

        }


        if (strFunctionalityMode == "VerticalByLevel") {

            //Adding functionality to plus and minus buttons on level by level mode

            objContainer.find(".VerticalByLevel .PlusLevel").click(function () { window.location = $(this).parent("li").find("> a").attr("href"); });

            objContainer.find(".VerticalByLevel .MinusLevel").click(function () { window.location = $(this).parent("li").parent("ul").parent("li").find("> a").attr("href"); });


        }

    };

    //Sort 
    function sortNumber(a, b) {
        return b - a;
    }

})(jQuery);